import escapeRegExp from "lodash/escapeRegExp";

export const createHighlightedText = (text: string, query: string) => {
  const parts: string[] = text.split(new RegExp(`(${escapeRegExp(query)})`, "gi"));
  return (
    <span>
      {parts.map((part, index) => (part.toLowerCase() === query.toLowerCase() ? part : <b key={index}>{part}</b>))}
    </span>
  );
};
